import type { IScheduledQuotesBlotterItem } from 'apiConnector/scheduledRun/scheduledQuotesBlotter';
import type { BlotterGridDispatchProps, BlotterGridStateProps } from 'components/shared/Blotter/Grid/blotter.model';
import { ClientSideBlotterGrid } from 'components/shared/Blotter/Grid/client-side-blotter';
import { connect } from 'react-redux';
import {
  getBlotterPreferenceState,
  getColumnDefinition,
  getItems,
  scheduledQuotesBlotterColumnStateChangedThunk,
  scheduledQuotesBlotterSelectionChangedThunk,
} from 'state/blotters/scheduledQuotes';
import { isScheduledQuotesBlotterVisible } from 'state/selectors/common/router';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type StateProps = BlotterGridStateProps<IScheduledQuotesBlotterItem> & {
  isSecondaryMarketPostTradeRedirectionAllowed: boolean;
  pagination?: boolean;
};

type DispatchProps = BlotterGridDispatchProps<IScheduledQuotesBlotterItem>;
const mapStateToProps = (state: AppState): StateProps => {
  return {
    items: getItems(state),
    columnDefinitions: getColumnDefinition(state),
    ...getBlotterPreferenceState(state),
    isSecondaryMarketPostTradeRedirectionAllowed: isScheduledQuotesBlotterVisible(state),
    pagination: false,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  onBlotterColumnStateChanged(columnState, columnGroupState) {
    dispatch(scheduledQuotesBlotterColumnStateChangedThunk(columnState, columnGroupState));
  },
  onSetActiveItem(item) {
    dispatch(scheduledQuotesBlotterSelectionChangedThunk(item?.id));
  },
});

export const connectScheduledQuotesBlotterGrid = connect(mapStateToProps, mapDispatchToProps);

export const ConnectedScheduledQuotesBlotterGrid = connectScheduledQuotesBlotterGrid(
  ClientSideBlotterGrid<IScheduledQuotesBlotterItem>,
);
